//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data () {
    return {
      circlesNum: 4
    }
  },

  computed: {
    borderWidth () {
      return this.size * 5 / 110
    },

    spinnerStyle () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`
      }
    },

    circleStyle () {
      return {
        animationDuration: `${this.animationDuration}ms`
      }
    },

    circleInnerContainerStyle () {
      return {
        borderWidth: `${this.borderWidth}px`
      }
    },

    circleInnerStyle () {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: `${this.borderWidth}px`
      }
    },

    circlesStyles () {
      const circlesStyles = []
      const delay = this.animationDuration * 0.15

      for (let i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(Object.assign({
          padding: `${this.borderWidth * 2 * i}px`,
          animationDelay: `${i === this.circlesNum - 1 ? 0 : delay}ms`
        }, this.circleStyle))
      }

      return circlesStyles
    }
  }
}
